import { useState } from "react";
import { Link } from "react-router-dom";
import { DollarSign, ShoppingCart, UserCog } from "lucide-react";
import { useSelector } from "react-redux";
import { RoutePages } from "../ultils";

const routes = [
  { ...RoutePages.HOME },
  { ...RoutePages.API_STATUS },
  {
    name: "API Services",
    icon: <ShoppingCart />,
    childs: [
      { ...RoutePages.DOCS.FB_GRAPH },
      { ...RoutePages.DOCS.FB_ACTION },
      { ...RoutePages.DOCS.TIKTOK },
    ],
  },
  {
    name: "Prices",
    icon: <DollarSign />,
    childs: [
      { ...RoutePages.PRICING.FB_GRAPH },
      {...RoutePages.PRICING.FB_ACTION},
      { ...RoutePages.PRICING.TIKTOK },
    ],
  },
  { ...RoutePages.MY_SUBSCRIPTIONS },
  { ...RoutePages.USER },
];

export default function Sidebar() {
  const authStore = useSelector((state) => state.auth);
  const [expanded, setExpanded] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      {/* Mobile Hamburger Button */}
      <button
        className="fixed top-4 left-4 z-40 md:hidden bg-gray-900 text-white p-2 rounded-md focus:outline-none"
        onClick={() => setMobileOpen(true)}
        aria-label="Open sidebar"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full bg-gray-900 z-30 text-white p-2 transition-all duration-0 ${expanded ? "w-64" : "w-16"
          } hidden md:block`}
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
      >
        <div className="flex flex-col gap-2 mt-4">
          {routes.map((item, index) => (
            <div key={index}>
              <Link
                key={index}
                to={item.path}
                className={`flex items-center gap-3 p-3 rounded-md ${item.element ? " hover:bg-gray-700" : "cursor-default"}`}
              >
                {item.icon}
                {expanded && <span>{item.name}</span>}
              </Link>
              {item.childs && (
                <div className="ml-6 border-l-2 border-blue-500">
                  {item.childs.map((child, childIndex) => (
                    <Link
                      key={childIndex}
                      to={child.path}
                      className="flex items-center gap-3 pl-4 p-2 hover:bg-gray-700 rounded-md"
                    >
                      {/* {child.icon} */}
                      {expanded && <span>{child.name}</span>}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
          {authStore.user?.username === "shadommc" && (
            <Link
              to="/admin"
              className="flex items-center gap-3 p-3 hover:bg-gray-700 rounded-md"
            >
              <UserCog />
              {expanded && <span>ADMIN PANEL</span>}
            </Link>
          )}
        </div>
      </div>

      {/* Mobile Sidebar Overlay */}
      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          {/* Overlay background */}
          <div
            className="absolute inset-0 bg-black opacity-40"
            onClick={() => setMobileOpen(false)}
          />
          {/* Sidebar content */}
          <div className="absolute top-0 left-0 h-full w-64 bg-gray-900 text-white p-4 shadow-lg z-50 flex flex-col">
            <button
              className="self-end mb-6 text-white"
              onClick={() => setMobileOpen(false)}
              aria-label="Close sidebar"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <div className="flex flex-col gap-4">
              {routes.map((item, index) => (
                <div key={index}>
                  <Link
                    to={item.path}
                    className={`flex items-center gap-3 p-3 rounded-md`}
                    onClick={() => setMobileOpen(false)}
                  >
                    {item.icon}
                    <span>{item.name}</span>
                  </Link>
                  {item.childs && (
                    <div className="ml-6 border-l-2 border-blue-500">
                      {item.childs.map((child, childIndex) => (
                        <Link
                          key={childIndex}
                          to={child.path}
                          onClick={() => setMobileOpen(false)}
                          className="flex items-center gap-3 pl-4 p-3 rounded-md"
                        >
                          <span>{child.name}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>

              ))}
              {authStore.user?.username === "shadommc" && (
                <Link
                  to="/admin"
                  className="flex items-center gap-3 p-3 rounded-md"
                  onClick={() => setMobileOpen(false)}
                >
                  <UserCog />
                  <span>ADMIN PANEL</span>
                </Link>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
